Vue.component('app-game-matching', {
    mounted: function() {
        game.matchmakingComponent = this;

        this.$root.$on('menuSocketCreated', (menuSocket) => {
            menuSocket.on('matchingData', (data) => {
                this.matchingData = data;
            });

            menuSocket.on('joinGame', (data) => {
                game.play(null, null, data);
            });

            menuSocket.on('exitMatchmaking', (data) => {
                this.cancel();
                if (data && data.message) {
                    game.showGrowl(data.message, {type: 'danger'});
                }
            });

            menuSocket.on('disconnect', () => {
                this.cancel();
            });
        });
    },
    unmounted: function() {
        this.cancel();
    },
    data: function() {
        return {
            shouldShowModal: false,
            matching: false,
            matchingStart: Date.now(),
            matchingTime: '0:00',
            matchingIntervalId: null,
            matchingData: {
                players: 1
            }
        };
    },
    methods: {
        showModal: function(val) {
            this.shouldShowModal = val;
        },
        startMatching: function(data) {
            if (!this.matching) {
                this.showModal(true);
                this.matching = true;
                this.matchingStart = Date.now();
                this.matchingTime = '0:00';
                game.services.socket.getMenuSocket().emit('enterMatchmaking', data);
                if (!this.matchingIntervalId) {
                    this.matchingIntervalId = setInterval(() => {
                        let diff = Date.now() - this.matchingStart;
                        let minutes = Math.floor(diff / 60000);
                        var seconds = ((diff % 60000) / 1000).toFixed(0);
                        this.matchingTime = minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
                    }, 1000);
                }

                if (window.ga) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Lobby',
                        eventAction: 'enterMatchmaking'
                    });
                }
            }
        },
        cancel: function() {
            this.showModal(false);
            if (this.matchingIntervalId) {
                clearInterval(this.matchingIntervalId);
                this.matchingIntervalId = null;
            }
            if (this.matching) {
                this.matching = false;
                game.services.socket.getMenuSocket().emit('exitMatchmaking', {});
            }
        }
    },
    template: `
    <div class="matching-modal" v-if="shouldShowModal">
        <h2>Matchmaking</h2>
        <i class="fa fa-circle-o-notch fa-4x fa-spin"></i>
        <br><br>
        <h3>{{matchingTime}}</h3>
        <h4>{{matchingData.players}} Players Searching</h4>
        <br><br>
        <button class="app-btn app-btn-danger app-btn-sm" v-on:click="cancel()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
    `
})